import React from 'react'

import AppointmentForm from '../../Components/Patient/AppointmentForm/AppointmentForm';
import Nav from '../../Components/Patient/Nav/Nav';
   
function AppointmentBooking() {
    return (
      <div>
        <Nav/>
        <AppointmentForm/>
      </div>
    );
  }


export default AppointmentBooking